<template>
  <div class="main-content main_center" :style="{'min-height':pageMinHeight}">
    <div style="margin-bottom: 10px" >
      <el-button @click="globalEdit = true" plain size="small" type="primary" v-if="!globalEdit">编辑</el-button>
      <el-button @click="saveCatalogueData" size="small" type="primary" v-if="globalEdit">保存</el-button>
      <el-button @click="globalEdit = false" size="small" v-if="globalEdit">取消编辑</el-button>
    </div>
    <el-divider style="margin-bottom:0px"></el-divider>
    <div class="leftTree" ref="leftTree" :style="`width:${treeWidth}px;`">
      <el-tree
        :data="treeData"
        node-key="id"
        :key="randomKey"
        ref="tree"
        empty-text="暂无数据"
        :props="cusProps"
        default-expand-all
        :highlight-current="true"
        @node-click="handleTreeNodeClick"
        @node-drag-start="handleDragStart"
        @node-drag-enter="handleDragEnter"
        @node-drag-leave="handleDragLeave"
        @node-drag-over="handleDragOver"
        @node-drag-end="handleDragEnd"
        @node-drop="handleDrop"
        draggable
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        :expand-on-click-node="true"
      >
        <span class="custom-tree-node" slot-scope="{ node,data }">
          <div v-if="node.isLeaf" @mouseover="data.hover = true" @mouseleave="data.hover = false">
            <div class="addNodeWrapper" v-if="data.edit">
<!--              <el-input style="width:210px;" v-model="nodeLabel"></el-input>-->
              <el-date-picker
                      style="width:210px;"
                      v-model="nodeLabel"
                      type="year"
                      value-format="yyyy"
                      placeholder="选择年">
              </el-date-picker>
              <el-button @click.stop="saveAddNode(node,data)" type="text">
                <i class="el-icon-success"></i>
              </el-button>
              <el-button @click.stop="cancelEditNode(node,data)" type="text">
                <i class="el-icon-error"></i>
              </el-button>
            </div>
            <div v-else>
              <span class="pointer"></span>
              <span>{{ node.label }} <span v-if="data.actived" style="color: red">（生效）</span></span>
              <span style="margin-left: 4px" v-if="globalEdit && data.hover">
                <el-button title="复制" @click.stop="copyNode(node,data)" class="svg-icon-btn" type="text">
                  <icon-svg class="svg-icon" name="ben"></icon-svg>
                </el-button>
                <el-button title="编辑" @click.stop="editNode(node,data)" class="svg-icon-btn" type="text">
                  <icon-svg class="svg-icon" name="edit"></icon-svg>
                </el-button>
                <el-button title="删除" @click.stop="deleteNode(node,data)" class="svg-icon-btn" type="text">
                  <icon-svg class="svg-icon" name="delete"></icon-svg>
                </el-button>
                <el-button title="设为生效" @click.stop="setNode(node,data)" class="svg-icon-btn" type="text">
                  <icon-svg class="svg-icon" name="system"></icon-svg>
                </el-button>
              </span>
            </div>
          </div>
          <div v-else>
            <span>{{ node.label }}</span>
          </div>
        </span>
      </el-tree>
      <div style="padding-left: 24px;margin: 16px auto">
        <el-button
          @click="addNode()"
          icon="el-icon-plus"
          plain
          size="mini"
          type="primary"
          v-if="globalEdit"
        >新增</el-button>
        <br />
        <div v-if="addNodeFlag" class="addNodeWrapper">
<!--          <el-input style="width:210px;margin-top: 10px" v-model="nodeLabel"></el-input>-->
          <el-date-picker
                  style="width:210px;margin-top: 10px"
                  v-model="nodeLabel"
                  type="year"
                  value-format="yyyy"
                  placeholder="选择年">
          </el-date-picker>
          <el-button @click="saveAddNode()" type="text">
            <i class="el-icon-success"></i>
          </el-button>
          <el-button type="text" @click="cancelEditNode()">
            <i class="el-icon-error"></i>
          </el-button>
        </div>
      </div>
    </div>
    <div @click="isShowTreeBtn('no')" :class="showTree?'isShowtreeBtn':'yinCang'">
      <i class="el-icon-arrow-left iconarrow"></i>
    </div>
    <div @click="isShowTreeBtn('yes')" :class="showTree?'yinCang':'showTree'">
      <i class="el-icon-arrow-right iconarrow"></i>
    </div>
    <div
      class="rightTable"
      :class="{'openRightTable':addNodeFlag}"
      :style="`width: calc(100% - ${treeWidth}px);height:${tableMaxHeight}px;overflow-y:scroll;`"
    >
      <el-card class="box-card" style="margin-bottom: 10px;position: relative">
        <div class="clearfix" slot="header">
          <span>采购品目</span>
        </div>
          <el-button style="position: absolute;right:118px;top: 10px" size="mini" @click="downloadTemplate" type="primary" v-if="globalEdit">
              <i class="el-icon-download"></i>下载模板
          </el-button>
        <el-button style="position: absolute;right:10px;top: 10px" size="mini" @click="importTemplate" type="primary" v-if="globalEdit">
          <i class="el-icon-upload"></i>导入表格
        </el-button>


        <catalogueItem :globalEdit="globalEdit" ref="catalogueItemRefA" :treeNodeId="currentNode.id" :catalogueType="'A'"></catalogueItem>
        <catalogueItem :globalEdit="globalEdit" ref="catalogueItemRefB" :treeNodeId="currentNode.id" :catalogueType="'B'"></catalogueItem>
        <catalogueItem :globalEdit="globalEdit" ref="catalogueItemRefC" :treeNodeId="currentNode.id" :catalogueType="'C'"></catalogueItem>

      </el-card>
    </div>
    <div style="clear:both;"></div>
      <input @change="fileChange" accept=".xls,.XLS,.xlsx,.XLSX" style="display: none" type="file" :ref="attachmentId">
  </div>
</template>

<script>
import catalogueItem from "@/views/modules/purchase/catalogue/catalogueItem";
import { httpMixinsCommonPost,httpMixinsCommonGet } from "@/server/purchase"
export default {
  components: {
    catalogueItem
  },
  data() {
    return {
      treeWidth: 274,
      showTree: true,
      nodeLabel: '',
      copyParentId:'',
      select: "1",
      globalEdit: false,
      sortable: null,
      pageMinHeight: document.documentElement.clientHeight - 128 + "px",
      tableMaxHeight: document.documentElement.clientHeight - 260,
        attachmentId: 'attachment' + new Date().getTime(),
      cusProps: {
        children: "children",
        label: "label"
      },
      form: {
        id: "",
        checkObjVos: [], // 检查对象
        checkRuleVos: [
          {
            configId: "",
            openFlag: true,
            ruleType: 1,
            ruleValue1: "",
            ruleValue2: ""
          },
          {
            configId: "",
            openFlag: true,
            ruleType: 2,
            ruleValue1: "",
            ruleValue2: ""
          },
          {
            configId: "",
            openFlag: true,
            ruleType: 3,
            ruleValue1: "",
            ruleValue2: ""
          }
        ] // 检查规则
      },
      rules: {
        checkType: [
          { required: true, message: "请选择执法检查类型", trigger: "change" }
        ],
        usableDeptCode: [
          {
            required: true,
            message: "请选择检查内容适用部门",
            trigger: ["blur", "change"]
          }
        ]
      },
      randomKey: Math.random(),
      hover: false,
      fileId: "",
      emptyArr: [],
      cameraDialogVisible: false,
      editWarmItemFlag: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      roleList: [],
      dialogVisible: false,
      dialogPersonVisible: false,
      currentNode: {},
      addNodeFlag: false,
      conditionJson: {
        minute: null,
        times: null
      },
      datetimerange: [],
      treeData: [
        {
          id: "1",
          label: "采购年度",
          level: 1,
          children: []
        }
      ],
      dataListLoading: false,
      whitePersonList: [],
      errorData: {},
      flownodeList: [],
    };
  },
  computed: {

  },
  created() {

  },
  activated() {
    this.getTreeData();
  },

  methods: {
      downloadTemplate(){
          this.$http({
              method: "get",
              url: `/purchase/item/downTemp`,
              responseType: "blob",
              baseURL:window.PUR_HTTP_API
          }).then(res => {
              const fileNames = res.headers['content-disposition'];
              if (fileNames) {
                  //解码
                  const fileName = decodeURIComponent(fileNames.match(/=(.*)$/)[1]);
                  // 处理返回的文件流
                  const content = res.data;
                  const contentType = res.headers['content-type'] || "application/octet-stream;charset=utf-8";
                  const blob = new Blob([content], {
                      type: contentType
                  });
                  if ('download' in document.createElement('a')) {
                      //非IE下载
                      const a = document.createElement('a') //创建一个a标签
                      a.download = fileName //指定文件名称
                      a.style.display = 'none' //页面隐藏
                      a.href = URL.createObjectURL(blob) // href用于下载地址
                      document.body.appendChild(a) //插到页面上
                      a.click() //通过点击触发
                      URL.revokeObjectURL(a.href) //释放URL 对象
                      document.body.removeChild(a) //删掉a标签
                  } else {
                      //IE10 + 下载
                      navigator.msSaveBlob(blob, fileName)
                  }

              }

          });
      },
      importTemplate(rowIndex){

          if(!this.currentNode.id){
              this.$message.error('请选择采购年度')
              return
          }

          this.$confirm("将以覆盖的方式导入采购品目，是否确定?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              center: true
          })
              .then(() => {
                  this.uploadBtn(rowIndex)
              })
              .catch(() => {
              });
      },
      uploadBtn(index) {
          this.selectRowIndex = index;
          this.$refs[this.attachmentId].click()
      },
      fileChange() {
          var that = this;
          let AllupExt = '.xls|.XLS|.xlsx|.XLSX'; // pdf  doc docx  xsl xlsx   png  jpg  jpeg  bmp
          let extName = this.$refs[that.attachmentId].files[0].name.substring(this.$refs[that.attachmentId].files[0].name.lastIndexOf('.')).toLowerCase();
          if (AllupExt.indexOf(extName + '|') == '-1') {
              this.$alert('文件格式不正确，请重新上传', '警告', {
                  confirmButtonText: '确定',
              })
              return;
          }
          let fd = new FormData();
          fd.append('file', this.$refs[that.attachmentId].files[0]);
          this.$http.post('/purchase/item/import?versionId=' + this.currentNode.id, fd,{baseURL: window.PUR_HTTP_API}).then(res => {
              if (res.data.code == "1") {
                  this.getTableList(this.currentNode.id)
              }else{
                  this.$message.error(res.data.msg)
              }
          })
      },
      
    handleDragStart(node, ev) {
      // console.log('drag start', node);
    },
    handleDragEnter(draggingNode, dropNode, ev) {
      // console.log('tree drag enter: ', dropNode);
    },
    handleDragLeave(draggingNode, dropNode, ev) {
      // console.log('tree drag leave: ', dropNode.label);
    },
    handleDragOver(draggingNode, dropNode, ev) {
      // console.log('tree drag over: ', dropNode.label);
    },
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      // console.log('tree drag end: ', dropNode && dropNode.label, dropType);
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      // console.log('tree drop: ', dropNode.label, dropType);
    },
    allowDrop(draggingNode, dropNode, type) {
      //拖拽时判定目标节点能否被放置
      if (!dropNode.isLeaf) {
        return false;
      }
      if (type == "next" || type == "prev") {
        return true;
      } else {
        return false;
      }
    },
    allowDrag(draggingNode) {
      //树节点等级判断是否可拖拽
      // return false;
      if (draggingNode.level == 2) {
        return true;
      } else {
        return false;
      }
    },
    indexMethod(index) {
      return index + 1;
    },
    //搜索按钮
    searchBtn(){
        this.pageIndex=1;
        this.getTreeData()
        },
    refresh() {//刷新按钮
        this.getTreeData()
        },
    isShowTreeBtn(flag) {
      if (flag === "no") {
        this.treeWidth = 0;
        this.showTree = false;
      } else if (flag === "yes") {
        this.treeWidth = 274;
        this.showTree = true;
      }
    },


    resetEdit() {
      this.globalEdit = false;
    },
    addNode(node, data) {
        if(this.addNodeFlag){
            this.$message({
                type: "error",
                message: '请先保存当前年份。'
            });
            return;
        }
        if(this.nodeLabel){
            this.$message({
                type: "error",
                message: '请先完成“'+this.nodeLabel+'”年度编辑。'
            });
            return;
        }

      this.addNodeFlag = true;
      this.currentNode = {};
      this.nodeLabel = '';
      this.copyParentId = '';
    },
    deleteNode(node, data) {

      this.$confirm(`确定要删除该数据?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpMixinsCommonPost("/purchase/itemVersion/delete", {
            id: data.id
          })
          .then(res => {
            if (res.data.code == "1") {
              this.$message({
                type: "success",
                message: res.data.msg
              });
              this.getTreeData();
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
      });
    },
    copyNode(node, data){
        if(this.addNodeFlag){
            this.$message({
                type: "error",
                message: '请先完成新增的保存。'
            });
            return
        }
      this.nodeLabel = data.year.toString();
      this.copyParentId = data.id;
      this.addNodeFlag = true;
    },
    editNode(node, data) {

        if(this.addNodeFlag){
            this.$message({
                type: "error",
                message: '请先完成新增的保存。'
            });
            return
        }

      data.edit = true;
      this.nodeLabel = data.year.toString();
      this.copyParentId = '';
    },
    setNode(node, data){
      this.$confirm(`确定要将该数据设置为生效吗？此操作将会把其他数据设置为失效。`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        httpMixinsCommonPost("/purchase/itemVersion/changeActive", {
          id:data.id,
          actived:1
        }).then(res => {
              if (res.data.code == "1") {
                this.getTreeData(data.id);
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg
                });
              }
            });
      });
    },
    saveCatalogueData(){
      let currentNode = JSON.parse(JSON.stringify(this.currentNode));
        const checkA = this.$refs.catalogueItemRefA.validateAndGetCatalogueItemForm();
        const checkB = this.$refs.catalogueItemRefB.validateAndGetCatalogueItemForm();
        const checkC = this.$refs.catalogueItemRefC.validateAndGetCatalogueItemForm();

        checkA.then(purchaseItemDtoListA=>{
            currentNode.purchaseItemDtoListA = purchaseItemDtoListA;
            checkB.then(purchaseItemDtoListB=>{
                currentNode.purchaseItemDtoListB = purchaseItemDtoListB;
                checkC.then(purchaseItemDtoListC=>{
                    currentNode.purchaseItemDtoListC = purchaseItemDtoListC;
                    httpMixinsCommonPost("/purchase/item/save", currentNode)
                        .then(res => {
                            if (res.data.code == "1") {
                                this.$message({
                                    type: "success",
                                    message: res.data.msg
                                });
                                this.globalEdit = false;
                                this.getTableList(currentNode.id);
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg
                                });
                            }
                        });
                }).catch((e)=>{
                    console.log(e)
                })
            }).catch((e)=>{
                console.log(e)
            })
        }).catch((e)=>{
            console.log(e)
        })


    },
    cancelEditNode(node, data) {
          if(node){
              data.edit = false;
              this.nodeLabel =  data.year.toString();
          }else{
              let nodeData = this.$refs.tree.getCurrentNode();
              if(nodeData){
                  this.nodeLabel =  nodeData.year.toString();
                  this.currentNode = nodeData;
              }
          }
        this.addNodeFlag = false;
        this.nodeLabel = '';

    },
    saveAddNode(node, data) {

        if(!this.nodeLabel){
            this.$message({
                type: "error",
                message: '请选择年份。'
            });
        }

      //保存检查对象
      if (node && data && this.nodeLabel) {
        data.label = this.nodeLabel + ' 年度';
        data.edit = false;
        data.year = this.nodeLabel;
        let nodeData = JSON.parse(JSON.stringify(data))
        nodeData.versionName = this.nodeLabel + ' 年度';
        nodeData.year = this.nodeLabel;
        httpMixinsCommonPost("/purchase/itemVersion/saveOrUpdate", nodeData)
          .then(res => {
            if (res.data.code == "1" && res.data.data.id) {
                this.addNodeFlag = false;
              this.getTreeData(res.data.data.id);
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
      } else if (this.nodeLabel) {
        let url = '/purchase/itemVersion/saveOrUpdate';
        if(this.copyParentId){
          url = '/purchase/itemVersion/copy'
        }
        httpMixinsCommonPost(url, {
            versionName:this.nodeLabel + ' 年度',
            year:this.nodeLabel,
            actived:0,
            parentId:this.copyParentId
          })
          .then(res => {
            if (res.data.code == "1" && res.data.data.id) {
                this.addNodeFlag = false;
              this.getTreeData(res.data.data.id);
            } else {
              this.$message({
                type: "error",
                message: res.data.msg
              });
            }
          });
      }

        this.nodeLabel = '';



      // if (node && data && this.nodeLabel) {
      //   data.label = this.nodeLabel
      //   data.edit = false;
      // }else if(this.nodeLabel){
      //   this.treeData[0].children.push({
      //         label:this.nodeLabel,
      //         hover:false,
      //         edit:false,
      //         checkItemVos:[],
      //         level:2,
      //         id:Math.random().toString(),
      //         actived:false
      //     })
      // }
      // this.addNodeFlag = false;

    },

    handleTreeNodeClick(data) {
      if (data.level == 2) {
        this.currentNode = data;
        this.getTableList(data.id);
      }
    },

    getTableList(id){
      if(id){
        httpMixinsCommonGet(`/purchase/itemVersion/get/${id}`).then((res)=>{
          if(res.data.code == '1'){
            this.$refs.catalogueItemRefA.setTableList(res.data.data.purchaseItemDtoListA);
            this.$refs.catalogueItemRefB.setTableList(res.data.data.purchaseItemDtoListB);
            this.$refs.catalogueItemRefC.setTableList(res.data.data.purchaseItemDtoListC);
          }else{
            this.$refs.catalogueItemRefA.setTableList([]);
            this.$refs.catalogueItemRefB.setTableList([]);
            this.$refs.catalogueItemRefC.setTableList([]);
            this.$message.error(res.data.msg)
          }
        })
      }

    },
    getTreeData(id) {
      this.dataListLoading = true;
      httpMixinsCommonPost('/purchase/itemVersion/getList',{}).then((res)=>{
        this.dataListLoading = false;
        let resData = res.data || [];
        let firstLeafNodeId = resData && resData[0] && resData[0].id ||  "";
        let treeData = resData.map(item => {
          return {
            ...item,
            label:item.versionName,
            disabledUpload: false,
            hover:false,
            level:2,
            edit:false,
          }
        });
        this.treeData[0].children = treeData;
        if (id || firstLeafNodeId != "") {
          this.$nextTick(()=>{
            let node = this.$refs.tree.getNode(id || firstLeafNodeId);
            if (node) {
              this.$refs.tree.setCurrentKey(node);
              this.currentNode = node.data;
              this.getTableList(node.data.id);
            }
          });
        }
      })

    },

  },
  mounted() {

  }
};
</script>
<style lang="less" scoped>
.main-content {
  position: relative;

  ::v-deep .el-divider--horizontal {
    margin-bottom: 0px;
  }

  .leftTree {
    // width: 274px;
    float: left;
    margin-bottom: 20px;
    padding: 10px 0px;
    ::v-deep .el-button + .el-button {
      margin-left: 4px;
    }

    ::v-deep .is-leaf.el-tree-node__expand-icon {
      display: none;
    }

    .addNodeWrapper {
      .el-range-editor.el-input__inner {
        padding: 3px 0px 3px 8px;
      }
    }

    .pointer {
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      margin: 2px 6px;
      background: rgba(0, 0, 0, 0.25);
    }

    .iconImg {
      width: 14px;
    }

    ::v-deep .el-tree-node__content {
      height: 36px;
      ::v-deep .el-icon-folder {
        padding: 0;
        display: none;
      }
    }

    .el-tree--highlight-current {
      ::v-deep .el-tree-node.is-current {
        > .el-tree-node__content {
          background-color: rgba(27, 154, 238, 0.1);
          color: rgba(27, 154, 238, 1);
        }
        .pointer {
          background-color: rgba(27, 154, 238, 1);
        }
      }
    }

    .custom-tree-node {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      width:100%;
    }

    ::v-deep span.is-leaf {
      padding: 0 !important;
    }
    .el-input {
      width: 150px !important;
    }
  }
  .rightTable {
    // width: calc(100% - 274px);
    float: right;
    border-left: 1px solid #dcdfe6;
    .svg-icon-btn {
      margin-left: 4px;
      &:hover {
        color: #1890ff;
      }
    }
    .switch-text {
      font-size: 12px;
      position: absolute;
      color: rgba(255, 255, 255, 1);
      line-height: 24px;
      cursor: pointer;
    }
    .switch-active {
      left: 7px;
    }
    .switch-inactive {
      right: 7px;
    }

    ::v-deep .input-slot-box {
      position: relative;
      display: inline-block;
      .el-input__inner {
        border-radius: 0px;
      }
      .el-input--suffix {
        .el-input__inner {
          padding: 0 4px;
          padding-right: 12px;
          border-left: none;
        }
      }

      .el-input-number__increase {
        top: 2px;
        line-height: 16px;
      }

      .el-input-number__decrease {
        bottom: 3px;
        line-height: 16px;
      }

      .el-input-icon {
        display: inline-block;
        height: 40px;
        text-align: center;
        line-height: 32px;
        background-color: rgba(245, 247, 250, 1);
        color: rgba(0, 0, 0, 0.85);
        border: 1px solid rgba(220, 223, 230, 1);
        position: absolute;
        top: 0px;
        border-radius: 0 4px 4px 0;
      }

      .el-input-icon.el-input-icon-ie {
        top: 0px;
      }

      .el-input-slot {
        width: 60px;
        right: 0px;
        border-radius: 0 4px 4px 0;
        border-left: none;
        border: none;
      }

      .el-input-slot-pre {
        width: 40px;
        position: absolute;
        left: 0px;
        border-radius: 4px 0 0 4px;
        border-right: none;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
  .isShowtreeBtn {
    width: 22px;
    height: 80px;
    line-height: 80px;
    text-align: right;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
    background-image: url(../../../../assets/img/close.png);

    position: absolute;
    left: 272px;
    top: 20%;
  }
  .yinCang {
    display: none;
  }
  .iconarrow {
    font-size: 16px;
  }
  .showTree {
    width: 22px;
    height: 80px;
    line-height: 80px;
    text-align: left;
    background-repeat: no-repeat;
    background-size: 100%;
    cursor: pointer;
    background-image: url(../../../../assets/img/open.png);
    position: absolute;
    left: 0px;
    top: 20%;
  }
  .isShowtreeBtn:hover {
    color: #1890ff;
  }
  .showTree:hover {
    color: #1890ff;
  }
  .openRightTable {
    width: calc(100% - 274px);
  }
}
</style>
